import React, { Component } from 'react';
import { Modal, Spin } from 'antd';
import { inject, observer } from 'mobx-react';
import { CartesianGrid, Legend, Line, LineChart, Tooltip, XAxis, YAxis, ReferenceLine } from 'recharts';
import moment from 'moment';
import { api } from '../../../../../../services';
import { round } from 'lodash';

@inject('translationsStore')
@observer
export default class BatteryHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      data: []
    };
  }

  componentDidMount() {
    if (this.props.carId) {
      this.loadBatteryData(this.props.carId);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.carId && this.props.carId !== prevProps.carId) {
      this.loadBatteryData(this.props.carId);
    }
  }

  loadBatteryData = carId => {
    this.setState({ loading: true });
    api('getCarBatteryLevelHistory', carId).then(response => {
      const data = response
        .sort((moment1, moment2) => {
          return moment2.recordedAt < moment1.recordedAt ? 1 : -1;
        })
        .map(sample => ({ date: sample.recordedAt, voltage: round(sample.value / 1000, 1) }));

      this.setState({
        loading: false,
        data
      });
    });
  };

  render() {
    const { translationsStore } = this.props;

    const data = this.state.data.map(sample => ({ ...sample, name: moment(sample.date).format('DD-MM HH:mm') }));

    const thresholdHealthy = 12;

    return (
      <Modal
        title={translationsStore.translate('carView.battery.batteryHistory.title')}
        visible={true}
        footer={null}
        onCancel={this.props.onCancel}
        width={600}
        bodyStyle={{ height: 350 }}
      >
        {this.state.loading ? (
          <Spin spinning={true}>
            <div style={{ width: 550, height: 200 }} />
          </Spin>
        ) : (
          <LineChart data={data} width={550} height={200} margin={{ top: 0, right: 0, bottom: 0, left: -30 }}>
            <ReferenceLine y={thresholdHealthy} label={translationsStore.translate('carView.battery.batteryHistory.reference')} stroke="red" strokeDasharray="3 3" />
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis tick={false} dataKey="name" padding={{ left: 20, right: 20 }} />
            <YAxis />
            <Tooltip formatter={(value, name, props) => [`${value} V`, translationsStore.translate(`carView.battery.batteryHistory.legend.${props.dataKey}`)]} />
            <Legend
              formatter={(value, entry) => {
                const { color } = entry;
                return <span style={{ color }}>{translationsStore.translate(`carView.battery.batteryHistory.legend.${value}`)}</span>;
              }}
            />
            <Line type="monotone" dataKey="voltage" stroke="#82ca9d" />
          </LineChart>
        )}
      </Modal>
    );
  }
}
